import React from 'react'
import { Paginator } from './Paginator';
import DataTable from 'react-data-table-component';
import { columns,data,tableCustomStylesII,tableCustomStyles } from '../utils';

const PortalDataTable = ({cols=columns,rows=data,misc,pagination=false,no_pagination=false,style2,loading,...rest}) => {
   

    return (
        <div className={'flex flex-col space-y-5 '}>
           <div className={'p-3  h-[63.5vh] overflow-y-scroll'}>
               <DataTable progressPending={loading} highlightOnHover pagination={pagination}  columns={cols} customStyles={style2?tableCustomStylesII:tableCustomStyles} data={rows}/>
           </div>
            {!no_pagination&&<div className={'flex justify-end px-3 items-center relative'}>
                <Paginator {...rest}/>
            </div>}
           
        </div>
    );
};

export const SideBarPortalDataTable = ({cols=columns,rows=data,misc,pagination=false,no_pagination=false,style2,loading,...rest}) => {

    return (
        <div className={'flex flex-col space-y-5 w-[100%]'}>
           <div className={'p-3'}>
               <DataTable progressPending={loading} highlightOnHover pagination={pagination}  columns={cols} customStyles={style2?tableCustomStylesII:tableCustomStyles} data={rows}/>
           </div>
            
           
        </div>
    );
};

export default PortalDataTable
